import { ReactNode } from "react"
import {
  BlockProps,
  HeadingXSmall,
  ModalBody,
  ModalFooter,
  ModalHeader,
  useStyletron,
} from "@mezo-org/mezo-clay"

type OnboardingModalContentProps = BlockProps & {
  children: ReactNode
  header?: ReactNode
  footer?: ReactNode
}

export default function OnboardingModalContent({
  children,
  header,
  footer,
}: OnboardingModalContentProps) {
  const [css] = useStyletron()

  return (
    <>
      {header && (
        <ModalHeader
          className={css({
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
          })}
        >
          <HeadingXSmall as="span">{header}</HeadingXSmall>
        </ModalHeader>
      )}
      <ModalBody $style={{ flex: 1 }}>{children}</ModalBody>
      {footer && (
        <ModalFooter className={css({ justifyContent: "center !important" })}>
          {footer}
        </ModalFooter>
      )}
    </>
  )
}
